import React from 'react'
import bell from '../../Images/Icons/bell.svg'

export default function NotificationBell() {
  return (
    <div>
      <img src={bell} alt='' style={{width:'20px'}}/>
    </div>
  )
}
